import { render, staticRenderFns } from "./PageOneView.vue?vue&type=template&id=063db688"
import script from "./PageOneView.vue?vue&type=script&lang=js"
export * from "./PageOneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports